module.exports = __webpack_public_path__ + "static/img/remind1.c802c0e5.png";